import { render, staticRenderFns } from "./distributor_region.vue?vue&type=template&id=39b30fa6&scoped=true"
import script from "./distributor_region.vue?vue&type=script&lang=js"
export * from "./distributor_region.vue?vue&type=script&lang=js"
import style0 from "./distributor_region.vue?vue&type=style&index=0&id=39b30fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b30fa6",
  null
  
)

export default component.exports